import { useSelector } from 'react-redux';

import { dateformatSelector } from '../selectors/globalsSelectors';

export function useDateFormat() {
  return useSelector(dateformatSelector);
}
